export default class ModeloAtividadeChecklist {

  constructor(
    IdModeloAtividade, IdChecklist, Descricao = '', Concluido, IdOrdem
  ) {
    this.IdModeloAtividade = IdModeloAtividade;
    this.IdChecklist = IdChecklist;
    this.Descricao = Descricao;
    this.Concluido = Concluido;
    this.IdOrdem = IdOrdem;  
  }
    
}